<app-schedule-grid (mySelected)='grid_onSelected($event)'></app-schedule-grid>
